import React, { useEffect } from 'react';

// styles
import styles from "./MeetingDetail.module.css"

// MUI
import Checkbox from '@mui/material/Checkbox';

const SeeInvitedPeopleInMeeting = (props) => {

    useEffect(() => {
        const newList = props.invitedPeople.map((item) => {
            return { ...item, status: false };
        });
        props.setInvitedPeople(newList);
    }, []);

    return (
        <>
            <div className="py-2">
                <div className="container-fluid">
                    <div
                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3 flex-wrap"
                        dir="rtl"
                    >
                        <div className='d-flex flex-column align-items-start justify-content-center mb-4'>
                            <div className={`mb-2 ${styles.title_text_bold}`}>
                                افراد حاظر در جلسه
                            </div>
                            <div className={`mt-2 ${styles.text_sm_gray}`}>
                                اسامی افرادی که در جلسه حظور داشتند را تیک بزنید
                            </div>
                        </div>
                        <div className='w-100 d-flex align-items-center justify-content-md-between flex-wrap mb-5'>
                            {props.invitedPeople?.map((item) => (
                                <div key={item.id} className='d-flex align-items-center justify-content-center m-md-0 m-2'>
                                    <Checkbox
                                        checked={item.status}
                                        onClick={() => statusHandler(item.consultant.id)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                        size="small"
                                        name="heldOn"
                                    />
                                    <div className={`d-flex align-items-center justify-content-center px-2 ${styles.invited_person}`}>
                                        <img className={`ms-2 ${styles.user_img}`} src={`https://backdev.azrmelk.com${item.consultant.imageUrl}`} alt="user-img" />
                                        <div className={styles.user_name}>
                                            {item.consultant.fullName}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    function statusHandler(id) {
        const itemSelected = props.invitedPeople.find((item) => id === item.consultant.id);
        const newState = props.invitedPeople.map(obj => {
            if (obj.consultant.id === id) {
                return { ...obj, status: !itemSelected.status };
            }
            return obj;
        });
        props.setInvitedPeople(newState);
    }
};

export default SeeInvitedPeopleInMeeting;